import { createAction } from "redux-actions";
import { SET_LANGUAGE, SET_DATA_LINE } from "../../constants/index";
import { apiGet } from "../../api/index";
import {
  urlGetLoginItemTemp,
  urlCompanyProtected,
  urlEmployeeProtected,
  urlAllEmployeeProtected,
  urlParcelsProtected,
} from "../../api/urls";

/**
 * Set TimeZone.
 */
export const setLanguage = createAction(SET_LANGUAGE, (data) => data);

/**
 * Get item.
 */
export const getLoginItem = createAction("GET_ITEM", (token) =>
  apiGet(urlGetLoginItemTemp, [token], false)()
);

/**
 * Get companies.
 */
export const getAllCompanies = createAction("GET_COMPANIES", (obj) =>
  apiGet(urlCompanyProtected, undefined, undefined)()
);

/**
 * Set TimeZone.
 */
export const setDataLine = createAction(SET_DATA_LINE, (data) => data);

export const getAllEmployees = createAction("GET_EMPLOYEES", (obj) =>
  apiGet(urlEmployeeProtected, undefined, undefined)()
);

const generateFilterAllQuery = ({ filters }) => {
  let filter = "?";
  if (filters) {
    if (filters.name !== undefined) filter += "name=" + filters.name;
  }
  if (filters) {
    if (filters.companyCode !== undefined) filter += "companyCode=" + filters.companyCode;
  }

  return filter;
};

export const filterAllEmployees = createAction(
  "FILTER_EMPLOYEES",
  (filter, param) =>
    apiGet(
      urlAllEmployeeProtected + generateFilterAllQuery(filter),
      param,
      true
    )()
);


export const getAllParcels = createAction("GET_PARCELS", (obj) =>
  apiGet(urlParcelsProtected, undefined, undefined)()
);